import { sortServerError } from 'utils/errors';

export const formatErrors = error => sortServerError(error);
